<template>
  <div class="dayRecord">
    <div class="ele-table-tool ele-table-tool-default">
      <span>日期：</span>
      <el-date-picker v-model="date" type="date" placeholder="选择日期" value-format="yyyy-MM-dd" style="margin-right: 10px; width: 150px" />
      <el-button @click="getDayData" type="primary" icon="el-icon-search" class="ele-btn-icon">查询 </el-button>
      <el-button type="primary" icon="el-icon-post" class="ele-btn-icon" @click="postSms">发短信 </el-button>
    </div>
    <ele-data-table
      size="mini"
      ref="table"
      :config="table"
      :data="data"
      :choose.sync="choose"
      @cell-click="getItemInfo"
      highlight-current-row
      height="calc(100vh - 330px)"
    >
      <template>
        <el-table-column type="selection" width="45" align="center" />
        <el-table-column v-for="(item, index) in examineAttendanceNameList" :key="index" :label="item">
          <template #default="{ row }">
            <span v-if="row[item].indexOf('-') == -1">{{ row[item] }}</span>
            <span v-else style="color: red">{{ row[item] }}</span>
          </template>
        </el-table-column>
      </template>
    </ele-data-table>
    <el-dialog title="检查通知单详情" :visible.sync="showInfo" width="40%" :destroy-on-close="true" :lock-scroll="false">
      <div class="ele-table-tool ele-table-tool-default">
        <el-button @click="removeInfo" type="danger" icon="el-icon-delete" class="ele-btn-icon">删除</el-button>
      </div>
      <ele-data-table ref="Infotable" :config="Infotable" :initLoad="false" :choose.sync="chooseInfo">
        <el-table-column type="selection" width="45" align="center" />
        <el-table-column prop="interviewee" label="姓名" show-overflow-tooltip />
        <el-table-column prop="className" label="班级" show-overflow-tooltip />
        <el-table-column prop="egiName" label="原因" show-overflow-tooltip />
        <el-table-column prop="score" label="得分" show-overflow-tooltip />
        <el-table-column prop="inputDate" label="日期" show-overflow-tooltip />
        <el-table-column label="操作" align="center">
          <template #default="{ row }">
            <el-link @click="edit(row)" icon="el-icon-edit" type="primary" :underline="false">修改</el-link>
          </template>
        </el-table-column>
      </ele-data-table>
    </el-dialog>
    <!--编辑检查单统计-->
    <el-dialog title="编辑检查单" :visible.sync="showEdit" width="35%" @closed="checkForm = {}" :destroy-on-close="true" :lock-scroll="false">
      <el-form :model="checkForm" ref="editForm" :rules="editRules" label-width="82px">
        <el-form
          ref="checkForm"
          :model="checkForm"
          :rules="editRules"
          label-width="110px"
          style="
            max-width: 700px;
            margin: 10px auto;
            overflow-y: scroll;
            overflow-x: scroll;
          "
        >
          <el-form-item label="姓名:" prop="interviewee">
            <el-input v-model="checkForm.interviewee" placeholder="请输入姓名" clearable />
          </el-form-item>
          <el-form-item label="日期:" prop="inputDate">
            <el-date-picker v-model="checkForm.inputDate" type="date" placeholder="选择日期" value-format="yyyy-MM-dd" />
          </el-form-item>
          <!-- <el-form-item label="违纪原因一级:" prop="egiId">
            <el-select v-model="egiId" placeholder="请选择违纪原因" class="ele-fluid" clearable  @change="getReasonListSec">
              <el-option v-for="(item,index) in reasonListFirst" :key="index" :label="item.egiName" :value="item.id"/>
            </el-select>
          </el-form-item> -->
          <el-form-item label="违纪原因二级:" prop="egiId">
            <el-select v-model="checkForm.egiId" placeholder="请选择违纪原因" class="ele-fluid" clearable>
              <el-option v-for="(item, index) in reasonListSec" :key="index" :label="item.egiName" :value="item.id" />
            </el-select>
          </el-form-item>
          <el-form-item label="分值:" prop="scoreId">
            <el-select v-model="checkForm.scoreId" placeholder="请选择分值" class="ele-fluid" clearable>
              <el-option v-for="(item, index) in scoreList" :key="index" :label="item.score" :value="item.id" />
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="照片:" prop="photo">
            <el-upload
                class="avatar-uploader"
                :action="$http.defaults.baseURL+'/file/getFilePath'"
                :headers="$http.defaults.headers.common"
                :data="{path:'checkListImg/'}"
                name="multipartFile"
                :show-file-list="false"
                :on-success="uploadSuccess"
                :before-upload="beforeAvatarUpload"
                accept="image/png,image/jpg,image/jpeg">
              <img v-if="checkForm.img" :src="checkForm.img" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item> -->
          <el-form-item label="督察员签字:" prop="signatory">
            <el-input v-model="checkForm.signatory" placeholder="请输入督察员" clearable />
          </el-form-item>
          <el-form-item label="备注:" prop="remark">
            <el-input type="textarea" v-model="checkForm.remark" placeholder="请输入备注" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="saveEdit" :loading="loading">提交</el-button>
          </el-form-item>
        </el-form>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
  import {
    deleteItemBillsByIds,
    getGeneralItemScoreByDate,
    sendEducationExamineBill,
    getItemScoreList,
    getItemLists,
    updateInformBill,
  } from '@/config/api';
  export default {
    name: 'DayRecord',
    data() {
      return {
        table: {
          // 表格配置
          page: false,
        },
        gradeId: '',
        date: this.$util.toDateString(new Date(), 'yyyy-MM-dd'),
        data: [],
        examineAttendanceNameList: [],
        choose: [],
        showInfo: false,
        chooseInfo: [],
        Infotable: {
          url: '/educationExamine/showItemBillsByClassIdDate',
          where: {
            classId: '',
            date: '',
            id: '',
          },
          page: false,
          parseData(res) {
            if (res.resCode == 200) res.code = 0;
            return res;
          },
        },
        checkForm: {},
        showEdit: false,
        editRules: {
          interviewee: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
          inputDate: [{ required: true, message: '请选择起止日期', trigger: 'change' }],
          egiId: [{ required: true, message: '请选择违纪原因', trigger: 'change' }],
          scoreId: [{ required: true, message: '请选择分则', trigger: 'change' }],
          signatory: [{ required: true, message: '请输入督察员', trigger: 'blur' }],
          remark: [{ required: true, message: '请输入备注', trigger: 'blur' }],
        },
        scoreList: [],
        reasonListSec: [],
        loading: false,
      };
    },
    methods: {
      // 获取每日一览数据
      getDayData() {
        let data = {
          date: this.date,
          gradeId: this.gradeId,
        };
        getGeneralItemScoreByDate(data).then((res) => {
          if (res.data.resCode == 200) {
            this.data = res.data.data.records;
            this.examineAttendanceNameList = res.data.data.examineAttendanceNameList;
          }
        });
      },
      // 获取检查单详情
      getItemInfo(row, column, cell, event) {
        console.log(row, column, cell, event);
        this.showInfo = true;
        this.$nextTick((res) => {
          console.log(res);
          let classId = row.classId;
          let id = row[column.label + '-id'];
          this.Infotable.where = {
            date: this.date,
            classId: classId,
            id: id,
          };
          this.$refs.Infotable.reload();
        });
      },
      // 删除详情
      removeInfo() {
        if (this.chooseInfo.length === 0) return this.$message.error('请至少选择一条数据');
        let ids = this.chooseInfo.map((d) => d.id);
        this.$confirm('确定要删除选中项吗?', '提示', { type: 'warning' }).then(() => {
          let data = new FormData();
          data.append('ids', ids);
          deleteItemBillsByIds(data).then((res) => {
            if (res.data.resCode == 200) {
              this.$message({ type: 'success', message: '已删除' });
              this.$refs.Infotable.reload();
              this.getDayData();
            } else {
              this.$message.error(res.data.resMsg);
            }
          });
        });
      },
      // 发送短信
      postSms() {
        let data = new FormData();
        data.append('date', this.date);
        data.append('gradeId', this.gradeId);
        sendEducationExamineBill(data).then((res) => {
          if (res.data.resCode == 200) {
            this.$message({ type: 'success', message: '已发送' });
          } else {
            this.$message.error(res.data.resMsg);
          }
        });
      },
      // 编辑检查单
      edit(row) {
        this.checkForm = Object.assign({}, row);
        this.getReasonListSec(row.firstId);
        this.getSocreList();
        this.showEdit = true;
      },
      // 获取分值列表
      getSocreList() {
        getItemScoreList().then((res) => {
          if (res.data.resCode == 200) {
            this.scoreList = res.data.data;
          }
        });
      },
      //照片上传限制
      beforeAvatarUpload(file) {
        const extension = file.name.substring(file.name.lastIndexOf('.') + 1) === 'png';
        const extension2 = file.name.substring(file.name.lastIndexOf('.') + 1) === 'jpg';
        if (!extension && !extension2) {
          this.$message.error('只能上传png、jpg格式的图片');
          return false;
        }
      },
      // 上传单个照片成功
      uploadSuccess(res) {
        if (res.resCode == 200) {
          this.checkForm.img = res.data[0].fileUrl;
        }
      },
      getReasonListSec(item) {
        getItemLists({ id: item }).then((res) => {
          if (res.data.resCode == 200) {
            this.reasonListSec = res.data.data;
          }
        });
      },
      saveEdit() {
        this.$refs['checkForm'].validate((valid) => {
          if (valid) {
            this.loading = true;
            let formData = new FormData();
            for (let key in this.checkForm) {
              if (this.checkForm[key] !== null && this.checkForm[key] !== undefined) {
                formData.append(key, this.checkForm[key]);
              }
            }
            updateInformBill(formData).then((res) => {
              this.loading = false;
              if (res.data.resCode == 200) {
                this.$message({ type: 'success', message: '修改成功' });
                this.showEdit = false;
                this.$refs.Infotable.reload();
              } else {
                this.$message.error(res.data.resMsg);
              }
            });
          } else {
            return false;
          }
        });
      },
    },
  };
</script>

<style scoped>
  .dayRecord {
    margin-top: 10px;
  }
  /* .avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
  border: 1px dashed #cccccc;
}
.avatar-uploader-icon:hover{
  border: 1px dashed #3aa1ff;
}
.avatar {
  width: 120px;
  height: 120px;
  display: block;
} */
</style>
